import { Check } from 'lucide-react';

import { META_CATEGORY_META } from './proactive-adapter';

import type { MetaCategory } from './types';

const ORDER: MetaCategory[] = ['customer_care', 'service', 'utility'];

interface Step2Props {
  category: MetaCategory | null;
  onPick: (c: MetaCategory) => void;
}

/**
 * Passo 2 — Categoria Meta. D1: só as 3 categorias que o v1 do backend aceita
 * (customer_care/service/utility). Marketing/Authentication/CTWA do mockup NÃO
 * são renderizadas — seriam affordance falsa (não há fatia que as habilite).
 * O custo `$`-`$$` é o literal informativo do briefing (estático).
 */
export function Step2Categoria({ category, onPick }: Step2Props): JSX.Element {
  return (
    <div className="coleta-section">
      <span className="coleta-section__label">Categoria Meta · custo e propósito</span>
      <div className="muted mono" style={{ fontSize: 10, marginBottom: 6 }}>
        A categoria define a janela e o custo do envio. O servidor valida a categoria conforme o
        plano e o estado do contato no momento do envio.
      </div>
      <div className="meta-cat-grid">
        {ORDER.map((id) => {
          const meta = META_CATEGORY_META[id];
          const isSel = category === id;
          return (
            <button
              key={id}
              type="button"
              className="meta-cat-card"
              data-state={isSel ? 'selected' : 'available'}
              onClick={() => onPick(id)}
            >
              <div className="meta-cat-card__head">
                <span className="meta-cat-card__name">{meta.label}</span>
                <span
                  className={
                    'meta-cat-card__cost' + (meta.cost === '—' ? ' meta-cat-card__cost--free' : '')
                  }
                >
                  {meta.cost === '—' ? '' : meta.cost}
                </span>
              </div>
              <span className="meta-cat-card__desc">{meta.desc}</span>
              <span className="meta-cat-card__state">{isSel ? '✓ selecionado' : 'disponível'}</span>
              {isSel && (
                <div className="meta-cat-card__check">
                  <Check size={11} />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
